import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';

import {
  NavBar,
  Heading,
  FilterList,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

interface IFilter {
  label: string;
  isMultiple: boolean;
  value: string;
  selectedFilters: string | string[];
  options: { label: string; value: string }[];
}

interface EmitEvents {
  (event: 'apply-filters', filters: IFilter[], count: number): void;
  (event: 'close'): void;
}
interface Props {
  isOpen: boolean;
  filters: IFilter[];
  clear?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarFilters',
  props: {
    isOpen: { type: Boolean },
    filters: null,
    clear: { type: Boolean, default: false }
  },
  emits: ["apply-filters", "close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'apply-filters', filters: IFilter[], count: number): void;
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean, filters: IFilter[], clear: boolean };





function handleChange(value: string, index: number, filter: IFilter) {
  if (filter.isMultiple) {
    filtersData.value[index].selectedFilters = value;
  } else if (filtersData.value[index].selectedFilters === value) {
    filtersData.value[index].selectedFilters = '';
  } else filtersData.value[index].selectedFilters = value;
}

watch(
  () => props.clear,
  clear => {
    if (clear) {
      clearFilters();
    }
  },
  { immediate: true }
);

const filtersData = ref<IFilter[]>([]);

const filterCount = computed(() => {
  let count = 0;

  filtersData.value.forEach(filter => {
    if (!filter.isMultiple && filter.selectedFilters) count += 1;
    else count += filter.selectedFilters.length;
  });

  return count;
});

function handleFilters() {
  const applyedFilters = filtersData.value.filter(
    filter => filter.selectedFilters.length > 0
  );

  emit('apply-filters', applyedFilters, filterCount.value);
}

function clearFilters() {
  filtersData.value = filtersData.value.map(filter => {
    return {
      ...filter,
      selectedFilters: filter.isMultiple ? [] : ''
    };
  });

  handleFilters();
}

onMounted(() => {
  filtersData.value = props.filters;
});

return { __sfc: true,emit, props, handleChange, filtersData, filterCount, handleFilters, clearFilters, NavBar, Heading, FilterList, ButtonContainer, ButtonPrimary, ButtonSecondary, SideSheet, BackButton }
}

})